import { IAggFunc } from "@ag-grid-community/core";
import { GenericTableCell } from "gen/model/genericTableCell";
import { GenericTableRow } from "gen/model/genericTableRow";
import { isNil, sum } from "lodash-es";
import { DataTableContext } from "shared/components/table/data/DataTableContext";
import { buildDataTableColumnContext } from "shared/components/table/data/internal/DataTableContextBuilders";
import { cellValueForAggregation } from "shared/components/table/data/internal/DataTableInternalUtils";
import { sumDecimalStrings } from "shared/utils/DecimalUtils";
import { sumMoneyStrings } from "shared/utils/MoneyUtils";
import { isTruthy } from "shared/utils/utils";

export const dataTableCellSumAggFunc: IAggFunc<
  GenericTableRow,
  GenericTableCell
> = (params): GenericTableCell | null => {
  const tableContext: DataTableContext = params.context;
  const result = tableContext.aggFunc?.(params);
  if (!isNil(result)) {
    return result;
  }

  const { column: columnData } = buildDataTableColumnContext(
    tableContext,
    params.column,
  );

  const cells = params.values.filter(isTruthy);

  if (cells.some((c) => c.form_field)) {
    const form = tableContext.getForm();
    if (form && columnData.aggregatable_type === "money") {
      return {
        value: {
          type: "money",
          amount: sumMoneyStrings(
            cells.map((c) => {
              const name = c.form_field?.name;
              return name ? form.getValues(name) : null;
            }),
          ),
        },
      };
    }
    return null;
  }

  if (columnData.aggregatable_type === "money") {
    return {
      value: {
        type: "money",
        amount: sumMoneyStrings(cells.map(cellValueForAggregation)),
      },
    };
  } else if (columnData.aggregatable_type === "decimal") {
    return {
      value: {
        type: "decimal",
        value: sumDecimalStrings(cells.map(cellValueForAggregation)).toString(),
      },
    };
  } else if (columnData.aggregatable_type === "integer") {
    return {
      value: {
        type: "integer",
        value: sum(cells.map(cellValueForAggregation).map(Number)),
      },
    };
  } else if (columnData.aggregatable_type === "percent") {
    return {
      value: {
        type: "percent",
        value: sumDecimalStrings(cells.map(cellValueForAggregation)).toString(),
      },
    };
  }
  return null;
};
